export const firebaseConfig = {
  apiKey: "AIzaSyCjLyKcEW9occRY9dX2mzd0_UCGhhJWwpM",
  authDomain: "dibson-dance-sandbox.firebaseapp.com",
  projectId: "dibson-dance-sandbox",
  storageBucket: "dibson-dance-sandbox.firebasestorage.app",
  messagingSenderId: "826772501877",
  appId: "1:826772501877:web:005fa160850d6e508d4f3c",
  measurementId: "G-3VPK1HGRBM"
};